var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { defaultProps } from './defaults';
import { DivTag, TableTag } from '../../Utils/AtomicTag';
import Item from './Item';
import Row from './Row';
import ResponsiveObserve, { responsiveArray } from './responsive';
export var Descriptions = function (props) {
    var title = props.title, children = props.children, hasBorder = props.hasBorder, column = props.column, _a = props.colon, colon = _a === void 0 ? false : _a, layout = props.layout, size = props.size, className = props.className, rest = __rest(props, ["title", "children", "hasBorder", "column", "colon", "layout", "size", "className"]);
    var DEFAULT_COLUMN_MAP = {
        xxl: 3,
        xl: 3,
        lg: 3,
        md: 3,
        sm: 2,
        xs: 1,
    };
    var _b = __read(React.useState({}), 2), screens = _b[0], setScreens = _b[1];
    /**
     * 响应式配置
     */
    React.useEffect(function () {
        var token = ResponsiveObserve.subscribe(function (newScreens) {
            if (typeof column !== 'object') {
                return;
            }
            setScreens(newScreens);
        });
        return function () {
            ResponsiveObserve.unsubscribe(token);
        };
    }, []);
    /**
     * screens变化时，会重新计算布局column
     * @param column
     * @param screens
     */
    var getColumn = function (column, screens) {
        if (typeof column === 'number') {
            return column;
        }
        if (typeof column === 'object') {
            for (var i = 0; i < responsiveArray.length; i++) {
                var breakpoint = responsiveArray[i];
                if (screens[breakpoint] && column[breakpoint] !== undefined) {
                    return column[breakpoint] || DEFAULT_COLUMN_MAP[breakpoint];
                }
            }
        }
        return 3;
    };
    var mergedColumn = getColumn(column, screens);
    /**
     * 获取二维数组
     * @param children
     * @param column
     */
    var getRows = function (children, column) {
        var rows = [];
        var tmpRow = [];
        var rowRestCol = column;
        var childrenArray = React.Children.toArray(children);
        // 处理异常情况/不足一行情况
        var getFilledItem = function (node, span, rowRestCol) {
            var clone = node;
            if (span === undefined || span > rowRestCol) {
                clone = React.cloneElement(node, {
                    span: rowRestCol,
                });
            }
            return clone;
        };
        React.Children.forEach(childrenArray, function (node, index) {
            var _a;
            var span = (_a = node.props) === null || _a === void 0 ? void 0 : _a.span;
            var mergedSpan = span || 1;
            if (index === childrenArray.length - 1) {
                tmpRow.push(getFilledItem(node, span, rowRestCol));
                rows.push(tmpRow);
                return;
            }
            if (mergedSpan < rowRestCol) {
                rowRestCol -= mergedSpan;
                tmpRow.push(node);
            }
            else {
                // 换行操作
                tmpRow.push(getFilledItem(node, mergedSpan, rowRestCol));
                rows.push(tmpRow);
                // 重置行
                rowRestCol = column;
                tmpRow = [];
            }
        });
        return rows;
    };
    var rows = getRows(children, mergedColumn);
    var descTableCls = ['text-left', 'w-full'];
    var descHeaderCls = ['text-base', 'font-medium', 'leading-6', 'mb-px-16'];
    return (React.createElement(DivTag, __assign({ name: Descriptions.NAME, className: "descriptions " + (hasBorder ? 'descriptions-bordered' : '') + " " + (size ? 'descriptions-' + size : '') + " " + className }, rest),
        title && (React.createElement(DivTag, { autoPrefixedClassName: "descriptions-header", atomics: descHeaderCls }, title && React.createElement(DivTag, { className: "title" }, title))),
        React.createElement(TableTag, { atomics: descTableCls, autoPrefixedClassName: "descriptions-table" },
            React.createElement("tbody", null, rows.map(function (row, index) { return (React.createElement(Row, { key: index, row: row, layout: layout, hasBorder: hasBorder, colon: colon })); })))));
};
Descriptions.defaultProps = defaultProps;
Descriptions.NAME = 'descriptions';
Descriptions.displayName = 'Descriptions';
Descriptions.Item = Item;
